import { render, staticRenderFns } from "./warehouseStatisticsWindow.vue?vue&type=template&id=32112a46&scoped=true&"
import script from "./warehouseStatisticsWindow.vue?vue&type=script&lang=js&"
export * from "./warehouseStatisticsWindow.vue?vue&type=script&lang=js&"
import style0 from "./warehouseStatisticsWindow.vue?vue&type=style&index=0&id=32112a46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32112a46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32112a46')) {
      api.createRecord('32112a46', component.options)
    } else {
      api.reload('32112a46', component.options)
    }
    module.hot.accept("./warehouseStatisticsWindow.vue?vue&type=template&id=32112a46&scoped=true&", function () {
      api.rerender('32112a46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Warehouse/components/warehousing/warehouseStatisticsWindow.vue"
export default component.exports